<template>
    <div class="pricingtable-settings">
        
        <div v-if="deviceStylesSetttings.desktopStyles">
            <!-- settings group: PLAN -->
            <div class="settings-group-title">
                <h6>Tables per row desktop</h6>
            </div>

            <!-- visible items on desktop -->
            <div class="setting">
                <b-form-group>

                    <label for="flexchild-desktopitems-input">Tables desktop: <span v-b-tooltip.hover.top title="Visible amount of tables per row for desktop view"><i class="far fa-question-circle"></i></span></label>
                    
                    <b-input-group size="sm">
                        <b-form-input id="flexchild-desktopitems-input" type="number" v-model="settingsFromWeebly.settings.amountDesktop" min="1" max="10" step="1" />
                    </b-input-group>

                </b-form-group>
            </div>
        </div> 

        <div v-if="deviceStylesSetttings.tabletStyles">
            <!-- settings group: PLAN -->
            <div class="settings-group-title">
                <h6>Tables per row tablet</h6>
            </div>

            <!-- visible items on tablet -->
            <div class="setting">
                <b-form-group>

                    <label for="flexchild-tabletitems-input">Tables tablet: <span v-b-tooltip.hover.top title="Visible amount of tables per row for tablet view"><i class="far fa-question-circle"></i></span></label>
                    
                    <b-input-group size="sm">
                        <b-form-input id="flexchild-tabletitems-input" type="number" v-model="settingsFromWeebly.settings.amountTablet" min="1" max="10" step="1" />
                    </b-input-group>

                </b-form-group>
            </div> 
        </div>

        <div v-if="deviceStylesSetttings.mobileStyles">
            <!-- settings group: PLAN -->
            <div class="settings-group-title">
                <h6>Tables per row mobile</h6>
            </div>

            <!-- visible items on mobile -->
            <div class="setting">
                <b-form-group>

                    <label for="flexchild-mobileitems-input">Tables phone: <span v-b-tooltip.hover.top title="Visible amount of items for phone view"><i class="far fa-question-circle"></i></span></label>
                    
                    <b-input-group size="sm">
                        <b-form-input id="flexchild-mobileitems-input" type="number" v-model="settingsFromWeebly.settings.amountPhone" min="1" max="10" step="1" />
                    </b-input-group>

                </b-form-group>
            </div>
        </div>



        

    </div>
</template>

<script>
import draggable from 'vuedraggable'
import Mycolorpicker from './Mycolorpicker'

export default {

    name: 'PricingtablesSettings',

    data() {
        return {
            errorInString: false
        }
    },

    computed:{

        settingsFromWeebly() {
            return this.$store.state.weeblySettings
        },

        globalSettings() {
            return this.$store.state
        },

        // device Styles
        deviceStylesSetttings() {
            return this.$store.state.deviceStyles
        },

        // google font picker
        googleFontsArray() {
            return this.$store.state.googleFontsToLoad
        }

    },

    mounted() {

    },

    components: {
        draggable,
        Mycolorpicker
    },

    methods: {
      // apply font in css
        applyFont() {

            console.log(event.target.value)

            let font = event.target.value

            // load google font
            this.$store.state.weeblySettings.settings.fontGoogleLoadPlan = font

            // convert font that equals id for checking checkbox
            font = font.split(':')

            let fontNameSplit = font[0]

            // remove possible + instances from fontNameSplit string
            if(fontNameSplit.includes('+')) {
                fontNameSplit = fontNameSplit.replace(/\+/g, " ")
                this.$store.state.weeblySettings.settings.fontFamilyPlan = '"'+fontNameSplit+'"'
            } else {
                this.$store.state.weeblySettings.settings.fontFamilyPlan = fontNameSplit
            }
            
            let fontStylePart = font[1]

            if( fontStylePart.includes('i') ) {
                let fontStylePartSplit = fontStylePart.split(/(i)/g)
                this.$store.state.weeblySettings.settings.fontStylePlan = 'italic'
                this.$store.state.weeblySettings.settings.fontWeightPlan = fontStylePartSplit[0]
            } else {
                this.$store.state.weeblySettings.settings.fontWeightPlan = fontStylePart
                this.$store.state.weeblySettings.settings.fontStylePlan = 'normal'
            }

        },  
    }
}
</script>

<style lang="less">
@import '../../../less/colors.less';
.errordisplay {
    border: 1px solid @warning_red;
    font-size: 12px;
    padding: 7px;
    font-weight: 700;
    border-radius: .25rem;
    margin: 7px auto;

    h2 {
        font-size: 14px;
    }

    span {
        font-style: italic;
        display: block;
        margin-top: 7px;
        color: @warning_red;
    }
}
</style>




// WEBPACK FOOTER //
// src/components/elements/elementSettings/PricingtablesSettings.vue